import DottedMap from 'dotted-map/without-countries'
import Panzoom from '@panzoom/panzoom'
import dottedMapData from '../../data/dotted-map.json'

const DOT_COLOUR = '#C8C8C8'
const DOT_RADIUS = 0.3
const MAP_HEIGHT = 140
const MAP_GRID = 'diagonal'
const MAP_REGION = {
	lat: { min: -56, max: 84 },
	lng: { min: -180, max: 180 },
}

class FlatWorldMap {
	constructor(el) {
		this.el = el
		this.mapEl = el.querySelector('[data-flat-world-map]')
		this.dataEl = el.querySelector('[data-flat-world-map-airlines]')
		if (!this.mapEl || !this.dataEl) return

		try {
			this.airlines = JSON.parse(this.dataEl.textContent)
		} catch (e) {
			this.airlines = []
		}

		const map = new DottedMap({
			map: dottedMapData,
			height: MAP_HEIGHT,
			grid: MAP_GRID,
			region: MAP_REGION,
		})

		this.airlines.forEach((airline) => {
			const lat = parseFloat(airline.lat)
			const lng = parseFloat(airline.lng)
			if (Number.isNaN(lat) || Number.isNaN(lng)) return
			if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return

			map.addPin({
				lat,
				lng,
				svgOptions: { radius: 0 },
				data: { airlineId: airline.id },
			})
		})

		this.mapEl.innerHTML = ''
		const wrapper = document.createElement('div')
		wrapper.className = 'flat-world-map__svg-wrapper'
		wrapper.innerHTML = map.getSVG({
			shape: 'circle',
			radius: DOT_RADIUS,
			color: DOT_COLOUR,
			backgroundColor: 'transparent',
		})
		this.mapEl.appendChild(wrapper)

		const svgEl = wrapper.querySelector('svg')
		if (!svgEl) return
		svgEl.style.width = '100%'
		svgEl.style.height = '100%'
		svgEl.style.display = 'block'

		const { width: vbW, height: vbH } = svgEl.viewBox.baseVal
		wrapper.style.aspectRatio = `${vbW} / ${vbH}`

		const outer = this.el.querySelector('.flat-world-map__map-outer')
		if (outer) outer.style.aspectRatio = `${vbW} / ${vbH}`

		map.getPoints()
			.filter((p) => p.data && p.data.airlineId)
			.forEach((point) => {
				const airline = this.airlines.find((a) => a.id === point.data.airlineId)
				if (!airline) return

				const marker = document.createElement('div')
				marker.className = 'flat-world-map__marker'
				marker.style.left = `${(point.x / vbW) * 100}%`
				marker.style.top = `${(point.y / vbH) * 100}%`
				marker.innerHTML = `<img class="flat-world-map__marker-logo" src="${airline.logo}" alt="${airline.alt || ''}" />`

				wrapper.appendChild(marker)
			})

		wrapper.setAttribute('data-lenis-prevent', '')

		const initialX = (this.mapEl.clientWidth - wrapper.clientWidth) / 2
		const initialY = (this.mapEl.clientHeight - wrapper.clientHeight) / 2

		const panzoom = Panzoom(wrapper, {
			maxScale: 4,
			minScale: 1,
			contain: 'outside',
			cursor: 'grab',
			startX: initialX,
			startY: initialY,
		})

		this.mapEl.addEventListener('wheel', (event) => {
			if (!event.shiftKey) return
			panzoom.zoomWithWheel(event)
		})

		wrapper.addEventListener('panzoomzoom', (event) => {
			wrapper.style.setProperty('--marker-counter-scale', 1 / event.detail.scale)
		})
	}
}

export const initFlatWorldMap = () => {
	document.querySelectorAll('.flat-world-map').forEach((el) => {
		new FlatWorldMap(el)
	})
}

export default () => {}
